export default "__VITE_ASSET__5f26a4a9__"